import { CheckBoxOutlined, CheckRounded } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import cx from 'classnames';
import { Integration } from 'js/constants/externalIntegrations';
import { ProfileImage } from 'new/elements/ProfileImage';
import { Switch } from 'new/elements/Switch';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import React, { ChangeEvent, MouseEventHandler } from 'react';
import styles from './IntegrationList.module.scss';

interface ItemDataProps {
  integration?: Integration;
  reverse?: boolean;
}

export interface ItemProps extends ItemDataProps {
  onOpenConfiguration?: MouseEventHandler<HTMLButtonElement>;
  isActive?: boolean;
  disableActivation?: boolean;
  onActivationChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

export const ItemData = ({ integration, reverse }: ItemDataProps) => {
  const {
    meta: { displayName, IconComponent },
  } = integration;

  return (
    <div className={cx(styles.itemDataContainer, reverse ? styles.itemDataContainerReverse : '')}>
      <Stack flexDirection="column">
        <Typography variant="subheading">{displayName}</Typography>
      </Stack>
      {IconComponent ? (
        <IconComponent width={40} height={40} />
      ) : (
        <ProfileImage fullName={displayName} />
      )}
    </div>
  );
};

export const Item = ({
  integration,
  onOpenConfiguration,
  onActivationChange,
  disableActivation,
  isActive,
}: ItemProps) => {
  const { isAdmin } = useCurrentUser();

  if (!integration) return null;
  const {
    meta: { description },
  } = integration;

  return (
    <div className={styles.itemContainer}>
      <div className={styles.itemContent}>
        <div className={styles.itemData}>
          <ItemData integration={integration} />
        </div>
        <Typography variant="body2">{description}</Typography>
      </div>
      <div className={styles.itemFooter}>
        {isAdmin ? (
          <Switch disabled={!!disableActivation} checked={isActive} onChange={onActivationChange} />
        ) : isActive ? (
          <div className={`${styles.configurationStatus} ${styles.active}`}>
            <CheckRounded />
            <Typography variant="caption">Enabled</Typography>
          </div>
        ) : (
          <div className={`${styles.configurationStatus} ${styles.inactive}`}>
            <Typography variant="caption">Inactive</Typography>
          </div>
        )}
        <Button color="primary" variant="text" onClick={onOpenConfiguration}>
          {isAdmin ? 'Configure' : 'View Configuration'}
        </Button>
      </div>
    </div>
  );
};
